// DOM Size Optimizer - Reduce elements and improve performance
(function() {
  
  // Virtual scrolling for large product lists
  function initVirtualScrolling() {
    const productGrids = document.querySelectorAll('[data-product-grid]');
    
    productGrids.forEach(grid => {
      const products = Array.from(grid.children);
      if (products.length <= 12) return; // Skip small lists
      
      // Only show first 12 products initially
      const visibleProducts = products.slice(0, 12);
      const hiddenProducts = products.slice(12);
      
      // Hide excess products
      hiddenProducts.forEach(product => {
        product.style.display = 'none';
        product.classList.add('dom-hidden');
      });
      
      // Add load more functionality
      if (hiddenProducts.length > 0) {
        const loadMoreBtn = document.createElement('button');
        loadMoreBtn.className = 'btn load-more-products';
        loadMoreBtn.textContent = `Load More Products (${hiddenProducts.length})`;
        loadMoreBtn.style.cssText = 'display: block; margin: 20px auto; padding: 12px 24px; border: 1px solid #ddd; background: #fff; cursor: pointer;';
        
        loadMoreBtn.addEventListener('click', () => {
          // Show next batch (8 at a time)
          const nextBatch = hiddenProducts.splice(0, 8);
          nextBatch.forEach(product => {
            product.style.display = '';
            product.classList.remove('dom-hidden');
          });
          
          if (hiddenProducts.length === 0) {
            loadMoreBtn.remove();
          } else {
            loadMoreBtn.textContent = `Load More Products (${hiddenProducts.length})`;
          }
        });
        
        grid.parentNode.insertBefore(loadMoreBtn, grid.nextSibling);
      }
    });
  }
  
  // Remove unnecessary DOM elements
  function cleanupDOM() {
    // Remove empty elements, but exclude app blocks and their children
    const emptyElements = document.querySelectorAll('div:empty, span:empty, p:empty');
    emptyElements.forEach(el => {
      // Exclude header and navigation elements from being removed
      if (el.closest('header, nav, .top-header, .navbar, .hamburger')) {
        return;
      }
      
      // Don't remove elements in app blocks (they might be placeholders for dynamic content)
      const isInAppBlock = el.closest('[class*="shopify-app"], [class*="instafeed"], [class*="elfsight"], [data-app-block]');
      if (!el.hasAttribute('data-keep') && !el.classList.contains('loader') && !isInAppBlock) {
        el.remove();
      }
    });
    
    // Merge adjacent text nodes, but not in app blocks
    const walker = document.createTreeWalker(
      document.body,
      NodeFilter.SHOW_TEXT,
      null,
      false
    );
    
    const textNodes = [];
    let node;
    while (node = walker.nextNode()) {
      textNodes.push(node);
    }
    
    textNodes.forEach(textNode => {
      // Exclude header and navigation elements
      if (textNode.parentElement && textNode.parentElement.closest('header, nav, .top-header, .navbar, .hamburger')) {
        return;
      }
      
      const isInAppBlock = textNode.parentElement && textNode.parentElement.closest('[class*="shopify-app"], [class*="instafeed"], [class*="elfsight"], [data-app-block]');
      if (!isInAppBlock && textNode.nextSibling && textNode.nextSibling.nodeType === Node.TEXT_NODE) {
        textNode.textContent += textNode.nextSibling.textContent;
        textNode.nextSibling.remove();
      }
    });
    
    // Remove redundant wrapper divs, but not in app blocks
    const redundantWrappers = document.querySelectorAll('div > div:only-child');
    redundantWrappers.forEach(wrapper => {
      // Exclude header and navigation elements
      if (wrapper.closest('header, nav, .top-header, .navbar, .hamburger')) {
        return;
      }
      
      const isInAppBlock = wrapper.closest('[class*="shopify-app"], [class*="instafeed"], [class*="elfsight"], [data-app-block]');
      if (isInAppBlock) return;
      
      const parent = wrapper.parentNode;
      const child = wrapper.firstElementChild;
      
      if (child && !wrapper.hasAttribute('class') && !wrapper.hasAttribute('id')) {
        // Move child's classes to parent if parent has none
        if (!parent.className && child.className) {
          parent.className = child.className;
        }
        parent.replaceChild(child, wrapper);
      }
    });
  }
  
  // Lazy load complex elements
  function initLazyElements() {
    // Lazy load non-critical carousels/sliders, but exclude app blocks
    const nonCriticalSliders = document.querySelectorAll('.slider:not(.hero), .carousel:not(.hero)');
    
    nonCriticalSliders.forEach(slider => {
      // Don't replace app block sliders
      const isInAppBlock = slider.closest('[class*="shopify-app"], [class*="instafeed"], [class*="elfsight"], [data-app-block]');
      if (isInAppBlock) return;
      
      if (slider.getBoundingClientRect().top > window.innerHeight * 2) {
        const placeholder = document.createElement('div');
        placeholder.className = 'slider-placeholder';
        placeholder.style.cssText = `height: 300px; background: #f5f5f5; display: flex; align-items: center; justify-content: center; color: #666;`;
        placeholder.innerHTML = '<span>Loading slider...</span>';
        
        const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              placeholder.replaceWith(slider);
              observer.disconnect();
            }
          });
        }, { rootMargin: '200px' });
        
        slider.replaceWith(placeholder);
        observer.observe(placeholder);
      }
    });
  }
  
  // Optimize review/testimonial sections
  function optimizeReviews() {
    const reviewSections = document.querySelectorAll('.reviews, .testimonials, [class*="review"]');
    
    reviewSections.forEach(section => {
      // Skip RLFP preview slider
      if (section.id === 'rlfp-preview-slider' || 
          section.classList.contains('rlfp-preview-slider') ||
          section.closest('.rlfp-preview-slider') ||
          section.closest('#rlfp-preview-slider')) {
        return;
      }
      
      const reviews = Array.from(section.children);
      if (reviews.length > 6) {
        // Hide reviews beyond first 6
        reviews.slice(6).forEach(review => {
          review.style.display = 'none';
        });
        
        // Add show more button
        const showMoreBtn = document.createElement('button');
        showMoreBtn.textContent = `Show More Reviews (${reviews.length - 6})`;
        showMoreBtn.className = 'btn show-more-reviews';
        showMoreBtn.style.cssText = 'margin: 15px auto; display: block; padding: 8px 16px; border: 1px solid #ddd; background: #fff;';
        
        showMoreBtn.addEventListener('click', () => {
          reviews.slice(6).forEach(review => {
            review.style.display = '';
          });
          showMoreBtn.remove();
        });
        
        section.appendChild(showMoreBtn);
      }
    });
  }
  
  // Limit nested elements depth
  function limitNesting() {
    const deepElements = [];
    
    function checkDepth(element, depth = 0) {
      if (depth > 25) { // Limit to 25 levels
        deepElements.push(element);
        return;
      }
      
      Array.from(element.children).forEach(child => {
        checkDepth(child, depth + 1);
      });
    }
    
    checkDepth(document.body);
    
    // Flatten deeply nested elements
    deepElements.forEach(element => {
      const parent = element.parentNode;
      if (parent && element.children.length === 1 && !element.hasAttribute('class')) {
        // Move child up if wrapper has no purpose
        const child = element.firstElementChild;
        parent.replaceChild(child, element);
      }
    });
  }
  
  // Initialize optimizations
  function init() {
    // Wait for initial render
    setTimeout(() => {
      cleanupDOM();
      initVirtualScrolling();
      initLazyElements();
      optimizeReviews();
      limitNesting();
      
      console.log(`DOM optimized: ${document.querySelectorAll('*').length} elements`);
    }, 100);
  }
  
  // Run when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
})();